export const createDivContainer = (className) =>
  $(`<div class="${className}"></div>`);

export const CATEGORY_SERIES_GRID = {
  classGridDrop: "audio-category-series-grid",
  classGridDropItem: "audio-category-series-grid-item",
  classGridDropContent: "audio-category-series-grid-content",
};

export const LevelDrop = {
  Level0: "0",
  Level1: "1",
  Level2: "2",
};

export const VIDEO_SERIES_GRID = {
  classGridDrop: "audio-video-series-grid",
  classGridDropItem: "audio-video-series-grid-item",
  classGridDropContent: "audio-video-series-grid-content",
};

export const VIDEO_SEASON_GRID = {
  classGridDrop: "audio-video-season-grid",
  classGridDropItem: "audio-video-season-grid-item",
  classGridDropContent: "audio-video-season-grid-content",
  selectorGridDropContentSlider: "[role=sliderwrapper]",
};
